export const placeSubcategories = [
  "가정식",
  "고기요리",
  "꼬치",
  "꽃배달",
  "남미음식",
  "닭강정",
  "디저트",
  "레저용품",
  "롤",
  "립",
  "마트",
  "막창,양",
  "만두",
  "먹장어요리",
  "민속주점",
  "보쌈",
  "빈대떡",
  "빙과류제조",
  "삼계탕",
  "샐러드",
  "샐러드뷔페",
  "생선요리",
  "설렁탕",
  "소바",
  "수목원",
  "순댓국",
  "실내놀이터",
  "영양탕",
  "전골",
  "제조",
  "조리식품제조",
  "주스전문점",
  "중식만두",
  "체험",
  "초밥뷔페",
  "커피",
  "컵밥",
  "파스타전문",
  "한과",
  "해물찜",
  "해물탕",
  "호프",
];
